
import MetisMenu from '@metismenu/react';
import React from 'react';
import { Link } from 'react-scroll';
export default function OnePageSideBar(){
    const SideBarRemove = () => {
        document.body.classList.remove('on-side');
    };
    return(
        <aside className="slide-bar off-canvas">
		<div className="close-mobile-menu"  onClick={SideBarRemove}>
			<i className="fas fa-times"></i>
		</div>
		
		<div className="offset-sidebar">
			<div className="offset-widget offset-logo mb-30">
				<Link to="index.html">
					<img src="assets/img/logo/header-logo-1.png" alt="logo" />
				</Link>
			</div>
			<div className="offset-widget mb-40">
				<div className="info-widget">
					<p className="mb-30">
						We help our clients succeed by
						creating brand identities, digital
						IT experiences, & print materials.
						Helping our clients reach their
						full potential on the market.
					</p>
					<div className="offset-social-link">
						<div className="social-icons">
							<Link className="fb" href="#" target="_blank"><i className="fab fa-facebook-f"></i></Link>
							<Link className="ttr" href="#" target="_blank"><i className="fab fa-twitter"></i></Link>
							<Link className="yh" href="#" target="_blank"><i className="fab fa-yahoo"></i></Link>
							<Link className="yt" href="#" target="_blank"><i className="fab fa-youtube"></i></Link>
						</div>
					</div>
					<div className="slidebar-address">
						<span>Get is touch</span>
						<p>2307 Beverley Rd
							Brooklyn, New York 11226
							United States.
							789 098 098 09</p>
					</div>
					<Link className="theme_btn theme_btn_bg offset-sidebar-btn" href="contact.html">Contact Us <i
							className="fas fa-long-arrow-right"></i></Link>
				</div>
			</div>
			<div className="offset-sidebar-bg"><img src="assets/img/pattern/offset-sidebar-bg.png" alt="" /></div>
		</div>
	
		<nav className="side-mobile-menu">
			<MetisMenu id="mobile-menu-active">
				<li><Link className='nav-link' to='home' spy={true} activeClass='nav-bar-link-active' smooth={true}  >Home</Link></li>
                <li><Link className='nav-link' to='about' spy={true}  smooth={true}  >About</Link></li>
                <li><Link className='nav-link' to='services' spy={true}  smooth={true}  >Services</Link></li>
                <li><Link className='nav-link' to='projects' spy={true}  smooth={true}  >Project</Link></li>
                <li><Link className='nav-link' to='news' spy={true}  smooth={true}  >News</Link></li>
                <li><Link className='nav-link' to='contact' spy={true}  smooth={true}  >Contact</Link></li>
			</MetisMenu>
		</nav>
		
	</aside>
    )
}